export default __webpack_public_path__ + "static/media/leaf.5e2c4564.svg";